export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const USER_INFO_LOADED = 'USER_INFO_LOADED';